// extracted by mini-css-extract-plugin
export default {"suggestBestTimeBtn":"SuggestBestTimeBtn-module__suggestBestTimeBtn___rS6iY"};